import { render } from "./StocksManager.vue?vue&type=template&id=e173ca56&scoped=true"
import script from "./StocksManager.vue?vue&type=script&lang=js"
export * from "./StocksManager.vue?vue&type=script&lang=js"

import "./StocksManager.vue?vue&type=style&index=0&id=e173ca56&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e173ca56"]])

export default __exports__